<template>
    <div id="public-page-widget-component">
        <widget-wrapper-component :title="$t('public_page_widget_component.title')" id-widget="public-page-widget">
            <template v-slot:options>
                <menu-actions-component
                    :actions="[
                        {
                            title: $t('public_page_widget_component.access_to_page'),
                            icon: 'mdi-exit-to-app',
                            emit: 'openPublicPage',
                            has_access: true,
                        },

                        {
                            title: $t('public_page_widget_component.send_link_by_mail'),
                            icon: 'mdi-email-outline',
                            emit: 'sendQrCode',
                            has_access: true,
                        },
                        {
                            title: $t('public_page_widget_component.copy_link'),
                            icon: 'mdi-link-variant',
                            emit: 'copyPublicPageLink',
                            has_access: true,
                        },
                    ]"
                    v-on:openPublicPage="openPublicPage"
                    v-on:sendQrCode="dialog_send_qr_code = true"
                    v-on:copyPublicPageLink="copy(device.public_page_url)"
                />
            </template>

            <template v-slot:default>
                <div v-if="device?.public_page_url">
                    <div class="d-flex justify-center mb-2">
                        <qrcode-vue ref="qrcode" :size="200" :value="device?.public_page_url" level="H" render-as="canvas" />
                    </div>
                    <div class="d-flex justify-center">
                        <v-btn color="primary" class="text-uppercase font-weight-bold" rounded @click="downloadQrCode()">
                            {{ $t('global.download_qrcode') }}
                        </v-btn>
                    </div>
                </div>
                <div v-else>
                    <p>{{ $t('global.no_qrcode') }}</p>
                </div>
            </template>
        </widget-wrapper-component>

        <v-dialog v-model="dialog_send_qr_code" max-width="700px">
            <v-card>
                <v-card-title>
                    <p class="text-uppercase font-weight-bold mb-1 line-height-24">
                        {{ $t('public_page_widget_component.send_link_by_mail') }}
                    </p>
                </v-card-title>

                <v-card-text class="pt-4 pb-0">
                    <v-form ref="form_send_qr_code">
                        <v-text-field v-model="email" :label="$t('login_account_component.email')" :rules="email_rules" filled />
                    </v-form>
                </v-card-text>

                <v-card-actions class="justify-end">
                    <v-btn text @click="dialog_send_qr_code = false">
                        <span class="font-weight-bold">{{ $t('global.cancel') }}</span>
                    </v-btn>

                    <v-btn :loading="loading_send_qr_code" class="btn-secondary-loader" color="secondary" text @click="sendQrCode()">
                        <span class="secondary--text font-weight-bold">{{ $t('reset_password_component.send') }}</span>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import WidgetWrapperComponent from '@/components/global/wrapper/WidgetWrapperComponent.vue'
import MenuActionsComponent from '@/components/global/containment/MenuActionsComponent.vue'
import QrcodeVue from 'qrcode.vue'
import GlobalRepository from '@/repositories/GlobalRepository'

export default {
    name: 'PublicPageWidgetComponent',
    components: { MenuActionsComponent, QrcodeVue, WidgetWrapperComponent },
    props: {
        device: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            dialog_send_qr_code: false,
            receiver: '',
            receiver_rules: [(v) => !!v || this.$t('global.field_required')],
            email: '',
            email_structure: /^\S+@\S+\.\S+$/,
            email_rules: [
                (v) => !!v || this.$t('login_account_component.email_required'),
                (v) => this.email_structure.test(v.replace(/\s+/g, '')) || this.$t('login_account_component.email_not_valid'),
            ],
            loading_send_qr_code: false,
        }
    },
    methods: {
        openPublicPage() {
            window.open(this.device.public_page_url)
        },

        downloadQrCode() {
            const qrComponent = this.$refs.qrcode
            if (!qrComponent) return

            const canvas = qrComponent.$el.querySelector('canvas')
            if (!canvas) return

            const ctx = canvas.getContext('2d')

            ctx.save()
            ctx.globalCompositeOperation = 'destination-over'
            ctx.fillStyle = '#fff'
            ctx.fillRect(0, 0, canvas.width, canvas.height)
            ctx.restore()

            // Maintenant on exporte
            const pngUrl = canvas.toDataURL('image/png')

            const link = document.createElement('a')
            link.href = pngUrl
            link.download = 'qrcode.png'
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
        },

        sendQrCode() {
            if (this.$refs.form_send_qr_code.validate()) {
                this.loading_send_qr_code = true

                GlobalRepository.sendUrlPagePublicForAsset(this.device.id_asset, this.receiver, this.email, this.device.public_page_url)
                    .then(() => {
                        this.showSnackbar('success', this.$t('public_page_widget_component.link_sent'))
                        this.dialog_send_qr_code = false
                    })
                    .catch((error) => {
                        this.manageError(error)
                    })
                    .finally(() => {
                        this.loading_send_qr_code = false
                    })
            }
        },
    },
}
</script>
